export default defineNuxtPlugin({
  enforce: 'post',
  setup() {
    addRouteMiddleware(
      (to) => {
        const inner = to.meta.layout
        if (inner === 'page' || inner === 'article')
          to.meta.layout = 'default'
      },
      { global: true },
    )
  },
})
